import { Alert, Text, Box, Spinner } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const PageLoading = () => {
  const { t } = useTranslation();
  return (
    <Box flex="none">
      <Alert
        status="info"
        borderRadius="15px"
        bgColor="primaryColor"
        color="white"
        boxShadow="2xl"
      >
        <Spinner />
        <Text pl="12px">{t('estimate.loading')}</Text>
      </Alert>
    </Box>
  );
};

export default PageLoading;
